import type { ReturnLineItem } from '@itsrever/returns-api-types'
import { LineItemSubtypes } from '@/redux/return/return-slice'

const sumBySubtype = (lineItems: ReturnLineItem[], subtype: string) =>
  lineItems
    .filter((item) => item.subtype === subtype)
    .reduce((sum, item) => sum + (item.total ?? 0), 0)

// Costs are negative line items; a 0-cost flat fee still emits a RETURN_SHIPPING_COST item.
export const isReturnShippingCharged = (lineItems?: ReturnLineItem[]) => {
  if (!lineItems?.length) return false

  const netShippingCost = -(
    sumBySubtype(lineItems, LineItemSubtypes.ShippingCost) +
    sumBySubtype(lineItems, LineItemSubtypes.Promotion)
  )
  const coveredByFreeReturn =
    sumBySubtype(lineItems, LineItemSubtypes.FreeReturnPromotion) > 0

  return netShippingCost > 0 && !coveredByFreeReturn
}
